import { render } from "./Hero.vue?vue&type=template&id=34e2a9c0&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-34e2a9c0"

export default script